/* Sección 8-B (timeline horizontal, prototipo): el carrusel manda.
   Se escucha su scroll (nativo, con snap), se deduce el hito activo y se
   encienden hitos y burbujas hasta él; la línea rosa avanza por transition
   de width al cambiar --ptlh-fill. Bidireccional: volver atrás apaga.

   Mejora progresiva: sin este archivo, o con prefers-reduced-motion, todo
   queda encendido y el carrusel sigue siendo deslizable. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(scope) {
    var root = (scope || document).querySelector('.ptlh');
    if (!root || root.dataset.ptlhInit) return;
    root.dataset.ptlhInit = '1';
    var carousel = root.querySelector('.ptlh__carousel');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ptlh__hito'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ptlh__rail-dot'));
    if (!carousel || !items.length) return;

    /* ---- Nav, rueda y hint (Mau, sesión 7): funcionales SIEMPRE,
       también con prefers-reduced-motion — son controles, no animación.
       Salto por asignación directa de scrollLeft (gotcha de la sección 2:
       el smooth programático puede bloquearse con snap). ---- */
    var prev = root.querySelector('[data-ptlh-prev]');
    var next = root.querySelector('[data-ptlh-next]');
    var hint = root.querySelector('.ptlh__hint');

    function cardStep() {
      if (items.length < 2) return carousel.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function jump(direction) {
      var previous = carousel.style.scrollBehavior;
      carousel.style.scrollBehavior = 'auto';
      carousel.scrollLeft += direction * cardStep();
      carousel.style.scrollBehavior = previous;
      syncNav();
    }

    function syncNav() {
      var max = carousel.scrollWidth - carousel.clientWidth;
      if (prev) prev.disabled = carousel.scrollLeft <= 2;
      if (next) next.disabled = carousel.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { jump(-1); });
    if (next) next.addEventListener('click', function () { jump(1); });
    carousel.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();

    /* Rueda del ratón → desplazamiento horizontal (snap proximity en
       escritorio para que no pelee). Trackpads horizontales pasan. */
    carousel.addEventListener('wheel', function (e) {
      if (carousel.scrollWidth <= carousel.clientWidth) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      /* En los extremos se deja pasar la rueda: si no, la página no puede seguir
         scrolleando en vertical mientras el puntero está sobre el carrusel. */
      var max = carousel.scrollWidth - carousel.clientWidth;
      if (e.deltaY < 0 && carousel.scrollLeft <= 0) return;
      if (e.deltaY > 0 && carousel.scrollLeft >= max - 1) return;
      e.preventDefault();
      carousel.scrollLeft += e.deltaY;
    }, { passive: false });

    /* El hint »»» se apaga al primer scroll real del carrusel. */
    if (hint) {
      carousel.addEventListener('scroll', function once() {
        hint.classList.add('is-done');
        carousel.removeEventListener('scroll', once);
      }, { passive: true });
    }

    /* ---- Progreso animado del raíl: esto sí respeta reduced motion. */
    if (reduce.matches) return;

    root.classList.add('ptlh--armed');
    var ticking = false;

    function update() {
      ticking = false;
      var max = carousel.scrollWidth - carousel.clientWidth;
      var index = 0;
      if (max > 0 && items.length > 1) {
        index = Math.round((carousel.scrollLeft / max) * (items.length - 1));
      }
      var fill = items.length > 1 ? (index / (items.length - 1)) * 100 : 100;
      root.style.setProperty('--ptlh-fill', fill + '%');
      items.forEach(function (el, i) {
        el.classList.toggle('ptlh__hito--on', i <= index);
      });
      dots.forEach(function (el, i) {
        el.classList.toggle('ptlh__rail-dot--on', i <= index);
      });
    }

    carousel.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  init(document);

  /* Re-render de la sección en el editor del theme. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
